import { AccountTypes } from "../../shared/models/AccountTypes";

export class Credentials {
    public username: string;
    public password: string;
    public accountType: AccountTypes;
}

export class ExternalCredentials {
    public externalAccountId: string;
    public externalToken: string;
    public accountType: AccountTypes;
}

export class NewCredentials {
    public accountId: string;
    public currentPassword: string;
    public newPassword: string;
}
